import * as React from 'react'
import { ReactElement } from 'react'
import EnumPicker, { EnumPickerLabel, EnumPickerProps } from './EnumPicker'

export type InvoiceApprovalStatusPickerProps = Partial<EnumPickerProps<InvoiceApprovalStatus>> &
    Required<Pick<EnumPickerProps<InvoiceApprovalStatus>, 'selectedOptions' | 'onOptionsSelect'>>

export enum InvoiceApprovalStatus {
    New = 'NEW',
    Active = 'ACTIVE',
    Approved = 'APPROVED',
    OwnerApproved = 'OWNER_APPROVED',
    Done = 'DONE',
    Rejected = 'REJECTED',
}

// The order matters for dropdowns.
export const InvoiceApprovalStatusLabels: Map<InvoiceApprovalStatus, EnumPickerLabel> = new Map<
    InvoiceApprovalStatus,
    EnumPickerLabel
>([
    [InvoiceApprovalStatus.New, { name: 'invoiceapproval.status.new', disabled: false }],
    [InvoiceApprovalStatus.Active, { name: 'invoiceapproval.status.active', disabled: false }],
    [InvoiceApprovalStatus.Approved, { name: 'invoiceapproval.status.approved', disabled: false }],
    [InvoiceApprovalStatus.OwnerApproved, { name: 'invoiceapproval.status.ownerapproved', disabled: false }],
    [InvoiceApprovalStatus.Done, { name: 'invoiceapproval.status.done', disabled: false }],
    [InvoiceApprovalStatus.Rejected, { name: 'invoiceapproval.status.rejected', disabled: false }],
])

export default function InvoiceApprovalStatusPicker(props: InvoiceApprovalStatusPickerProps): ReactElement {
    return (
        <EnumPicker<InvoiceApprovalStatus>
            options={[...InvoiceApprovalStatusLabels.keys()]}
            labels={InvoiceApprovalStatusLabels}
            placeholderKey={'invoiceapproval.status.placeholder'}
            {...props}
        />
    )
}
